import {Grid, styled} from "@mui/material";
import { primary } from "../../common/theme";

const BLOG_GRID_PREFIX = "BlogGrid";

export const blogGridClasses = {
    root: `${BLOG_GRID_PREFIX}-root`,
    header: `${BLOG_GRID_PREFIX}-header`,
    card: `${BLOG_GRID_PREFIX}-card`,
    cardLocation: `${BLOG_GRID_PREFIX}-cardLocation`,
    cardImg: `${BLOG_GRID_PREFIX}-cardImg`,
    cardContent: `${BLOG_GRID_PREFIX}-cardContent`,
    button: `${BLOG_GRID_PREFIX}-button`,
    keywords: `${BLOG_GRID_PREFIX}-keywords`,
    keywordtag: `${BLOG_GRID_PREFIX}-keywordTag`,
    topRow: `${BLOG_GRID_PREFIX}-topRow`,
    dateText: `${BLOG_GRID_PREFIX}-dateText`,
    readTimeText: `${BLOG_GRID_PREFIX}-readTimeText`,
    separator: `${BLOG_GRID_PREFIX}-separator`,
    title: `${BLOG_GRID_PREFIX}-title`,
    excerpt: `${BLOG_GRID_PREFIX}-excerpt`,
};

export const StyledBlogGrid = styled(Grid)(({ theme }) => ({
    [`&.${blogGridClasses.root}`]: {
        
    },
    [`& .${blogGridClasses.header}`]: {
        display: "block",
        color: primary,
        margin: "20px 0 20px 0",
        [theme.breakpoints.up('lg')]: {
            margin: "70px 0 20px 0",
        },
        zIndex: 100,
        textAlign: "left",
        fontSize: "36px",
        lineHeight: "42px",
        fontWeight: "400"
    },
    [`& .${blogGridClasses.card}`]: {
        background: "transparent",
        color: "#fff",
        boxShadow: "none",
        position: "relative",
        cursor: "auto",
        marginBottom: "20px",
        display: "flex",
        flexDirection: "column",
        height: "100%",
    },
    [`& .${blogGridClasses.cardLocation}`]: {
        position: "absolute",
        padding: "10px",
        alignItems: "center",
        [`& img`]: {
            marginRight: "15px"
        },
        [`& h6`]: {
            fontWeight: "normal"
        },
        width: "45%",
        top: 5,
        left: 5,
        background: `${primary}8F`,
        borderRadius: "5px",
        justifyContent: "space-around"
    },
    [`& .${blogGridClasses.cardImg}`]: {
        height: "250px",
        borderRadius: "8px"
    },
    [`& .${blogGridClasses.cardContent}`]: {
        padding: "15px 0 5px 0",
        flex: "1",
    },
    [`& .${blogGridClasses.topRow}`]: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "12px",
        flexWrap: "wrap",
        gap: "8px",
    },
    [`& .${blogGridClasses.keywords}`]: {
        display: "flex",
        gap: "4px",
        flexWrap: "wrap",
        flex: 1,
    },
    [`& .${blogGridClasses.keywordtag}`]: {
        fontSize: "14px",
        lineHeight: "17px",
        fontWeight: "400",
        background: "#e8e8e8",
        color: "#333",
        borderRadius: "50px",
        padding: "5px 10px",
        cursor: "pointer"
    },
    [`& .${blogGridClasses.dateText}`]: {
        fontSize: "14px",
        color: "#666",
        fontWeight: "400",
    },
    [`& .${blogGridClasses.readTimeText}`]: {
        fontSize: "14px",
        color: "#666",
        fontWeight: "400",
    },
    [`& .${blogGridClasses.separator}`]: {
        margin: "12px 0",
        borderColor: "#e0e0e0",
    },
    [`& .${blogGridClasses.title}`]: {
        fontSize: "18px",
        fontWeight: "bold",
        lineHeight: "24px",
        color: "#011E3F",
        marginBottom: "12px",
        width: "100%",
    },
    [`& .${blogGridClasses.excerpt}`]: {
        fontSize: "14px",
        lineHeight: "20px",
        color: "#666",
        marginBottom: "16px",
    },
    [`& .${blogGridClasses.button}`]: {
        fontSize: "16px",
        fontWeight: "normal",
        background: "#011E3F",
        textTransform: "capitalize",
        borderRadius: "10px",
        height: "48px",
        minWidth: "185px",
        marginTop: "auto"
    },
}));

